var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62656 0.500026L6.62731 0.500025C7.25241 0.499097 7.8772 0.524164 8.5 0.575141V2.32202H7.37151C6.67142 2.32202 6.11046 2.478 5.74989 2.89599C5.40337 3.29769 5.34697 3.82736 5.34697 4.29252V6.22202V6.72202H5.84697H8.3259L8.05912 8.74801H5.84697H5.34697V9.24801V16.5H3.15929V9.24801V8.74801H2.65929H0.5V6.72202H2.65929H3.15929V6.22202V3.99502C3.15929 2.80941 3.52621 1.95075 4.10734 1.38758C4.69121 0.821765 5.54732 0.500025 6.62656 0.500026Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIconLight);
export default __webpack_public_path__ + "static/media/linkedinIconLight.7665435dbba587b5982d21d1684e84e1.svg";
export { ForwardRef as ReactComponent };